export default "__VITE_ASSET__B3xDD0gh__"